import { NgModule } from '@angular/core';
import { TimeInputComponent } from './time-input.component';

@NgModule({
  imports: [TimeInputComponent],
  exports: [TimeInputComponent],
})
export class TimeInputModule {}
